import IconChevronDown from '@apollo/icons/small/IconChevronDown.svg';
import {
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuContent,
  MenuGroup,
  MenuItem,
  MenuList,
} from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

import { SelectionPathNode } from '../helpers/graphqlHelpers';
import { isMac } from '../helpers/isMac';

import { FieldToggle } from './fieldToggle/FieldToggle';
import { FieldToggleType } from './getFieldToggle/getFieldToggle';

export const SelectAllButtonAndDropdown = ({
  node,
  fieldToggle,
  isSelectAllScalarsDisabled,
}: {
  node: SelectionPathNode;
  fieldToggle?: FieldToggleType;
  isSelectAllScalarsDisabled: boolean | null;
}) => {
  return (
    <ButtonGroup isAttached>
      <Tooltip
        placement="top"
        label={
          fieldToggle?.areAllFieldsSelected?.(node) ||
          fieldToggle?.isAnyFieldSelected?.()
            ? 'Remove All Fields'
            : `Click to add all fields (${
                isMac ? '⌘' : 'Ctrl'
              } + Click to add all fields recursively)`
        }
      >
        <IconButton
          aria-label="Toggle fields"
          variant="hidden"
          size="sm"
          onClick={(event) => {
            if (
              !fieldToggle?.isAnyFieldSelected?.() &&
              (event.metaKey || event.ctrlKey)
            ) {
              fieldToggle?.insertAllFieldsRecursively(node, false);
            } else {
              fieldToggle?.toggleAllFields(node);
            }
          }}
          icon={
            <FieldToggle
              checked={
                fieldToggle?.areAllFieldsSelected?.(node)
                  ? 'checked'
                  : fieldToggle?.isAnyFieldSelected?.()
                    ? 'mixed'
                    : 'unchecked'
              }
            />
          }
        />
      </Tooltip>
      <Menu placement="bottom-start" autoSelect={false}>
        <MenuButton
          as={IconButton}
          aria-label="Select all dropdown"
          size="sm"
          variant="hidden"
        >
          <IconChevronDown />
        </MenuButton>
        <MenuContent>
          <MenuList>
            <MenuGroup>
              <Tooltip
                placement="right"
                label="There are no scalar fields"
                disabled={!isSelectAllScalarsDisabled}
              >
                <MenuItem
                  onClick={() => {
                    fieldToggle?.insertAllCurrentScalars?.(node);
                  }}
                  isDisabled={isSelectAllScalarsDisabled ?? false}
                >
                  Select all scalar fields
                </MenuItem>
              </Tooltip>
              <MenuItem
                onClick={() => {
                  fieldToggle?.insertAllFieldsRecursively?.(node, false);
                }}
              >
                Select all fields recursively (up to 6 levels)
              </MenuItem>
            </MenuGroup>
          </MenuList>
        </MenuContent>
      </Menu>
    </ButtonGroup>
  );
};
